import { createAsyncThunk } from "@reduxjs/toolkit";
import GrafanaClient from "../../config/grafanaClient";
import { notificationFail } from "../slices/notificationSlice";
import { InitialStateType } from "../slices/exportHistory";

export const getExportHistoryData:any = createAsyncThunk(
  "getExportHistoryData",
  async (_request: any, { dispatch }) => {
    try {
      const response = await GrafanaClient().post("/report/export-center-list");

      return  response?.data?.result?.Items;
      // return {
      //   items: response?.data?.result?.Items,
      // } as InitialStateType;
    } catch (err: any) {
      dispatch(
        notificationFail(
          err?.response?.data?.message ||
            "something went wrong. Please try again."
        )
      );
    }
  }
);

export const getReportS3SignedUrl = createAsyncThunk(
  "getReportS3SignedUrlData",
  async (_request: any, { dispatch }) => {
    try {
      const response = await GrafanaClient().post("/export-report/get-report-s3-signed-url", {
        fileData:_request?.fileData
      });
      return response?.data?.signedUrl;
    } catch (err: any) {
      dispatch(
        notificationFail(
          err?.response?.data?.message ||
            "something went wrong. Please try again."
        )
      );
    }
  }
);